export interface InventoryAdjustmentRow {
  id: string
  code: string
  reference: string
  warehouse: string
}

export interface AdjustmentLine {
  id: string
  /** Server line id when editing an existing adjustment */
  apiLineId?: number
  itemId: string
  batchId: string
  currentQty: number
  newQty: number
}

export function newAdjustmentLine(): AdjustmentLine {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    itemId: '',
    batchId: '',
    currentQty: 0,
    newQty: 0,
  }
}

/** Delta: new quantity − current (book) quantity. 100 → 90 is -10. */
export function quantityAdjusted(line: AdjustmentLine): number {
  const current = Number(line.currentQty)
  const next = Number(line.newQty)
  const c = Number.isFinite(current) ? current : 0
  const n = Number.isFinite(next) ? next : 0
  return n - c
}
